import React, { ReactElement } from 'react'

type Props = {
    iconName?: string
}

const MenuItemIcon: React.FC<Props> = ({ iconName }: Props): ReactElement =>
    iconName ? <img className='omea-icon' src={`/CCS/Styles/Images/${iconName}.svg`} /> : <></>

export default MenuItemIcon
